/* eslint-disable */
import libraries from '../arduino/libraries'

export default function init(Blockly, profile) {
    Blockly.Arduino.math = {};
    Blockly.Arduino.math_number = function() {
        var a = window.parseFloat(this.getFieldValue("NUM"));
        return [a, 0 > a ? Blockly.Arduino.ORDER_UNARY_PREFIX : Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.math_to_int = function() {
        var a = "(long)(" + (Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC) || "0") + ")";
        return [a, 0 > a ? Blockly.Arduino.ORDER_UNARY_PREFIX : Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.math_to_uint = function() {
        var a = "(unsigned long)(" + (Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC) || "0") + ")";
        return [a, 0 > a ? Blockly.Arduino.ORDER_UNARY_PREFIX : Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.math_angle = function() {
        var a = window.parseInt(this.getFieldValue("ANGLE"));
        return [a, 0 > a ? Blockly.Arduino.ORDER_UNARY_PREFIX : Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.math_angle_180 = Blockly.Arduino.math_angle;
    Blockly.Arduino.math_atan2 = function() {
        var a = Blockly.Arduino.valueToCode(this, "NUM1", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "NUM2", Blockly.Arduino.ORDER_ATOMIC) || "0";
        return ["atan2(" + a + "," + b + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.math_arithmetic = function() {
        var a = this.getFieldValue("OP"),
            b = Blockly.Arduino.math_arithmetic.OPERATORS[a];
        a = b[0];
        b = b[1];
        var c = Blockly.Arduino.valueToCode(this, "A", b) || "0",
            d = Blockly.Arduino.valueToCode(this, "B", b) || "0";
        return a ? ["(" + c + a + d + ")", b] : ["pow(" + c + ", " + d + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.math_arithmetic.OPERATORS = {
        ADD: [" + ", Blockly.Arduino.ORDER_ADDITIVE],
        MINUS: [" - ", Blockly.Arduino.ORDER_ADDITIVE],
        MULTIPLY: [" * ", Blockly.Arduino.ORDER_MULTIPLICATIVE],
        DIVIDE: [" / ", Blockly.Arduino.ORDER_MULTIPLICATIVE],
        POWER: [null, Blockly.Arduino.ORDER_NONE]
    };
    Blockly.Arduino.math_single = function() {
        var a = this.getFieldValue("OP");
        if ("NEG" == a) {
            var b = Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_UNARY_PREFIX) || "0";
            "-" == b[0] && (b = " " + b);
            return ["-" + b, Blockly.Arduino.ORDER_UNARY_PREFIX]
        }
        b = "ABS" == a || "ROUND" == a.substring(0, 5) ? Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_UNARY_POSTFIX) || "0" : "SIN" == a || "COS" == a || "TAN" == a || "ASIN" == a || "ACOS" == a || "ATAN" == a ? Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_MULTIPLICATIVE) || "0" :
            Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_NONE) || "0";
        switch (a) {
            case "ROOT":
                a = "sqrt(" + b + ")";
                break;
            case "LOG":
                a = "log(" + b + ")";
                break;
            case "LOG10":
                a = "log10(" + b + ")";
                break;
            case "ABS":
                a = "abs(" + b + ")";
                break;
            case "ROUND":
                a = "round(" + b + ")";
                break;
            case "ROUNDUP":
                a = "ceil(" + b + ")";
                break;
            case "ROUNDDOWN":
                a = "floor(" + b + ")";
                break;
            case "SIN":
                a = "sin(" + b + ")";
                break;
            case "COS":
                a = "cos(" + b + ")";
                break;
            case "TAN":
                a = "tan(" + b + ")";
                break;
            case "ASIN":
                a = "asin(" + b + ")";
                break;
            case "ACOS":
                a = "acos(" + b + ")";
                break;
            case "ATAN":
                a =
                    "atan(" + b + ")";
                break;
            default:
                throw "Unknown math operator: " + a;
        }
        return a ? [a, Blockly.Arduino.ORDER_UNARY_POSTFIX] : [a, Blockly.Arduino.ORDER_MULTIPLICATIVE]
    };
    Blockly.Arduino.math_change = function() {
        var a = Blockly.Arduino.valueToCode(this, "DELTA", Blockly.Arduino.ORDER_ADDITIVE) || "0",
            b = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VARNUM"), Blockly.VARIABLE_CATEGORY_NAME);
        return b + "=" + b + "+(" + a + ");\n"
    };
    Blockly.Arduino.math_round = Blockly.Arduino.math_single;
    Blockly.Arduino.math_trig = Blockly.Arduino.math_single;
    Blockly.Arduino.math_modulo = function() {
        var a = Blockly.Arduino.valueToCode(this, "DIVIDEND", Blockly.Arduino.ORDER_MULTIPLICATIVE) || "0",
            b = Blockly.Arduino.valueToCode(this, "DIVISOR", Blockly.Arduino.ORDER_MULTIPLICATIVE) || "0";
        return ["(((int)" + a + ") % ((int)" + b + "))", Blockly.Arduino.ORDER_MULTIPLICATIVE]
    };
    Blockly.Arduino.math_map = function() {
        var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "FROMLOW", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = Blockly.Arduino.valueToCode(this, "FROMHIGH", Blockly.Arduino.ORDER_ATOMIC) || "Infinity",
            d = Blockly.Arduino.valueToCode(this, "TOLOW", Blockly.Arduino.ORDER_ATOMIC) || "0",
            e = Blockly.Arduino.valueToCode(this, "TOHIGH", Blockly.Arduino.ORDER_ATOMIC) || "Infinity";
        return ["map(" + a + ", " + b + "," + c + "," + d + "," + e + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.math_constrain = function() {
        var a = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "LOW", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = Blockly.Arduino.valueToCode(this, "HIGH", Blockly.Arduino.ORDER_ATOMIC) || "Infinity";
        return ["constrain(" + a + ", " + b + "," + c + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.math_random_int = function() {
        Blockly.Arduino.setups_.setup_random = "randomSeed(analogRead(0));";
        var a = Blockly.Arduino.valueToCode(this, "FROM", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "TO", Blockly.Arduino.ORDER_ATOMIC) || "0";
        return [Blockly.Arduino.provideFunction_("math_random_int", ["double " + Blockly.Arduino.FUNCTION_NAME_PLACEHOLDER_ + "(int a,int b) {", "  if (a > b) {", "    int c = a;", "    a = b;", "    b = c;", "  }", "  return (double)random(a,b+1);", "}"]) +
            "(" + a + ", " + b + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX
        ]
    };

    Blockly.Arduino.filter = {};
    Blockly.Arduino.filter_median_window = function() {
        // Get values selected
        const pin = this.getFieldValue("ID");
        const samples = Blockly.Arduino.valueToCode(this, "WINDOW", Blockly.Arduino.ORDER_ATOMIC);

        Blockly.Arduino.includes_.push(libraries.median_filter);

        Blockly.Arduino.definitions_.define_filter = "#include <MedianFilterLib2.h>";
        Blockly.Arduino.definitions_["var_filter_" + pin] = "MedianFilter2<double> medianFilter_" + pin + "(" + samples + ");";
        return ""
    };

    Blockly.Arduino.filter_median_add = function() {
        var a = this.getFieldValue("ID"),
            b = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC);
            Blockly.Arduino.includes_.push(libraries.median_filter);

        Blockly.Arduino.definitions_.define_filter = "#include <MedianFilterLib2.h>";
        Blockly.Arduino.definitions_["var_filter_" + a] || (Blockly.Arduino.definitions_["var_filter_" + a] = "MedianFilter2<double> medianFilter_" + a + "(5);");
        return ["medianFilter_" + a + ".AddValue(" + b + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
}